import { Injectable } from "@angular/core";
import { BehaviorSubject, take } from "rxjs";

import { StateService } from "./base-states/base-state";
import { IUserFamilyDto, IUserFamilyStateModel } from "../../shared/models/user-family.model";
import { UserFamilyService } from "../http-services/user-family.service";

const initialState: IUserFamilyStateModel = {
    familyMembers$: new BehaviorSubject<IUserFamilyDto[]>([])
};

@Injectable({
    providedIn: 'root'
})

export class UserFamilyStateService extends StateService<IUserFamilyStateModel> {

    constructor(
        private readonly userFamilyService: UserFamilyService
    ) {
        super(initialState);
    }

    loadFamily(): void {
        this.userFamilyService.getMyFamily().subscribe({
            next: (data) => {
                this.state.familyMembers$.next([...(data ?? [])]);
            },
            error: (err) => console.error('Failed to load family:', err)
        });
    }

    refreshFamily(): void {
        this.userFamilyService.getMyFamily().pipe(take(1)).subscribe({
            next: (data) => {
                this.state.familyMembers$.next([...(data ?? [])]);
            },
            error: (err) => console.error('Failed to load family:', err)
        });
    }

    getFamily() {
        const subject = this.state.familyMembers$;

        subject.pipe(take(1)).subscribe(data => {
            if (!data || data.length === 0) {
                this.loadFamily();
            }
        });

        return subject;
    }
}